import { useHistory } from 'react-router-dom';
import { Botao } from '../Botao';
import Card from '../Card';
import { Icone } from '../Icone';
import { Conteiner, Divisor, Cabecalho, ConteudoDoCabecalho, Titulo } from './styles';

export function CorpoDaPagina({ titulo, children, voltar = false }) {
  let historico = useHistory();

  return (
    <Conteiner>
      <Card>
        <Cabecalho>
          <ConteudoDoCabecalho>
            {voltar && (
              <Botao cor='background' texto='Voltar' aoClicar={() => historico.goBack()}>
                <Icone nome='FaLongArrowAltLeft' tamanho={16} />
              </Botao>
            )}
            <Titulo>{titulo}</Titulo>
          </ConteudoDoCabecalho>
          <Divisor />
          {children}
        </Cabecalho>
      </Card>
    </Conteiner>
  );
}
